import React from "react";
import { MDBIcon } from 'mdbreact';
import { URLImgFront } from '../../../../config/URLDB';
import ReactDOM from 'react-dom';

class ProductoModal extends React.Component {
    render() {
        const { producto, onClose, onRedimir } = this.props;

        if (!producto) return null;
        const isMobile = window.innerWidth < 768;
        const isTablet = window.innerWidth >= 768 && window.innerWidth < 992;

        const modal = (
            <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 1000, backgroundColor: 'rgba(0,0,0,0.4)', overflowY: 'auto', paddingTop: '120px' }} className="d-flex align-items-start align-items-md-center justify-content-center" >
                <div className="d-flex flex-column flex-md-row position-relative w-100" style={{ backgroundColor: '#fff', borderRadius: isMobile ? '14px' : '20px', maxWidth: isMobile ? '85%' : isTablet ? '680px' : '900px', padding: isMobile ? '20px 15px' : isTablet ? '24px' : '30px', gap: isMobile ? '15px' : '30px', boxShadow: '0 10px 30px rgba(0,0,0,0.2)', marginTop: 'auto', marginBottom: 'auto', }}>
                    <button onClick={onClose} className="position-absolute d-flex align-items-center justify-content-center" style={{ top: '10px', right: '10px', background: '#f5f5f5', border: 'none', borderRadius: '50%', width: isMobile ? '28px' : '35px', height: isMobile ? '28px' : '35px', cursor: 'pointer', padding: 0, zIndex: 1, }} onMouseEnter={(e) => (e.currentTarget.style.background = '#e0e0e0')} onMouseLeave={(e) => (e.currentTarget.style.background = '#f5f5f5')} aria-label="Cerrar modal" >
                        <MDBIcon icon="times" size={isMobile ? 'sm' : 'lg'} style={{ color: '#666' }} />
                    </button>

                    <div className="d-flex flex-column align-items-center justify-content-center text-center" style={{ flex: '1', paddingTop: isMobile ? '5px' : '10px' }}>
                        <img src={`${URLImgFront}/assets/EstrategiasComerciales/Coopenautas${producto.img}`} alt={producto.descredencion} className="img-fluid" style={{ maxWidth: isMobile ? '55%' : '80%', borderRadius: isMobile ? '8px' : '12px', maxHeight:'300px' }} />
                        <h4 style={{ marginTop: isMobile ? '10px' : '20px', fontWeight: '600', color: '#666', fontSize: isMobile ? '14px' : '20px', }}>
                            Descripción:
                        </h4>
                        <p style={{ color: '#777', fontSize: isMobile ? '12px' : '18px', marginBottom: 0, }}>
                            {producto.descripcion}
                        </p>
                    </div>

                    <div className="d-flex flex-column justify-content-center" style={{ flex: '1' }}>
                        <h2 style={{ color: '#009A00', marginBottom: '4px', fontSize: isMobile ? '18px' : '28px', }}>
                            {producto.descredencion}
                        </h2>
                        <h1 style={{ color: '#009A00', fontWeight: '800', marginTop: 0, fontSize: isMobile ? '12px' : '36px', }}>
                            {producto.valor} puntos
                        </h1>
                        {this.props.puntos > 0 && producto.cantidad > 0 && (
                            <>
                                <button onClick={onRedimir} className="w-100 mt-2" style={{ backgroundColor: '#FF6A00', color: '#fff', border: 'none', padding: isMobile ? '8px' : '12px', borderRadius: '10px', fontWeight: '600', cursor: 'pointer', fontSize: isMobile ? '13px' : '15px', }}>
                                    Agregar al carrito
                                </button>
                            </>
                        )}

                        <div className="mt-2" style={{ color: '#666', fontSize: isMobile ? '12px' : '30px', }}>
                            <p className="mb-1"><strong>Color:</strong> {producto.color}</p>
                            <p className="mb-1"><strong>Material:</strong> {producto.material}</p>
                            <p className="mb-1"><strong>Cantidad:</strong> {producto.cantidad > 0 ? producto.cantidad : 'No disponible.'}</p>
                        </div>
                    </div>
                </div>
            </div>
        );

        return ReactDOM.createPortal(modal, document.body);
    }
}

export default ProductoModal;